module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ChapTitle"
  }, [_c('span', {
    staticClass: "un"
  }, [_c('a', {
    attrs: {
      "id": "link3"
    }
  }), _vm._v("CHEVRON SHRUG")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-aut"
  }, [_vm._v("by Caroline Fairbanks-Critchfield")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/flow.jpg"
    }
  }), _vm._v(" Chevrons are all the rage, and this little jacket puts them on you! Cute and comfortable, it looks great made with any light- to medium-weight knit fabric that has stripes. A serger is not required for this project.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "80%",
      "src": "images/pg13_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "aut-head"
  }, [_vm._v("MEET THE DESIGNER")]), _vm._v(" "), _c('p', {
    staticClass: "aut-txt"
  }, [_vm._v("Read more about Caroline in "), _c('span', {
    attrs: {
      "href": "#/35_chapter29#link50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg14_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "fis"
  }, [_c('span', {
    staticClass: "col"
  }, [_vm._v("Finished size:")]), _vm._v(" varies")]), _vm._v(" "), _c('p', {
    staticClass: "fis"
  }, [_c('span', {
    staticClass: "col"
  }, [_vm._v("Fabric:")]), _vm._v(" Baby Hacci knit from Girl Charlee")])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "link4"
    }
  }), _vm._v("FABRIC REQUIREMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "ctxt"
  }, [_vm._v("Fabric must be a 58˝–60˝-wide striped knit with stripes running perpendicular to the selvage. (If you want to make a cute shrug without the chevron effect, striped fabric is not necessary.) We suggest jersey, interlock, or sweater knit.")]), _vm._v(" "), _c('p', {
    staticClass: "ctxt"
  }, [_vm._v("Choose the size based on your bust measurement.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg14_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Additional supplies")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "ocol"
  }, [_vm._v("•")]), _vm._v(" "), _c('b', [_vm._v("Ballpoint sewing machine needle")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "ocol"
  }, [_vm._v("•")]), _vm._v(" "), _c('b', [_vm._v("Water- or air-soluble fabric-marking pen")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "ocol"
  }, [_vm._v("•")]), _vm._v(" "), _c('b', [_vm._v("Sew-in or fusible stay tape")]), _vm._v(" (sheer tape used to stabilize and prevent stretching)")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("CUTTING")])]), _vm._v(" "), _c('p', {
    staticClass: "scut"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg15_1.jpg"
    }
  }), _vm._v(" "), _c('i', [_vm._v("Patterns are on "), _c('span', {
    attrs: {
      "href": "#/37_chapter31#pg232",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pullout")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "scut"
  }, [_c('i', [_vm._v("The key to the chevron design on this shrug is careful layout and cutting. After that, the rest is easy!")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg15_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("1")]), _vm._v(" Arrange your fabric on a large cutting area with the fabric folded in half and the selvage edges together. Take care that the stripes are lined up on both the top and bottom of your fabric so the same stripe runs along the bottom layer, up around the fold, and on top of itself on the top layer. This should be the same for the whole piece of fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("2")]), _vm._v(" Place the back pattern piece on the fabric, making sure the diagonal stripe line runs along 1 of the stripes. Place pattern weights over the pattern piece after it is arranged.")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("3")]), _vm._v(" Place the front pattern piece on the fabric, ensuring that the diagonal stripe line runs in the direction of the stripes. Move your pattern piece around until the "), _c('span', {
    staticClass: "ocol"
  }, [_c('b', [_vm._v("*")])]), _vm._v(" symbols at the shoulder on the front pattern piece are in the same spot in relation to the stripes as the "), _c('span', {
    staticClass: "ocol"
  }, [_c('b', [_vm._v("*")])]), _vm._v(" symbols on your back pattern piece. When you are sure that you have arranged your pattern pieces correctly, cut the fabric pieces.")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("4")]), _vm._v(" Cut 2 collar strips using the measurements in the "), _c('a', {
    attrs: {
      "href": "#/08_chapter02#link4"
    }
  }, [_vm._v("Fabric Requirements table")]), _vm._v(". To create the look on our shrug, cut the collar piece parallel to the selvage.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg15_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sew"
  }, [_vm._v("Sewing")]), _vm._v(" "), _c('p', {
    staticClass: "s-txt"
  }, [_c('i', [_vm._v("Use a stretch stitch (see "), _c('span', {
    attrs: {
      "href": "#/34_chapter28#link37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stretch Stitching")]), _vm._v(") or a serger and ballpoint needle(s).")])]), _vm._v(" "), _c('p', {
    staticClass: "s-txt"
  }, [_c('i', [_vm._v("Seam allowances are ½˝ unless otherwise noted.")])]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("1")]), _vm._v(" Cut 2 pieces of stay tape or seam stabilizer the length of the back shoulder seam. Stitch or fuse it to the wrong side of the back shoulder within the ½˝ seam allowance. "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("A")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg16_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("2")]), _vm._v(" Pin together the back pieces along the center back seam, with right sides facing, matching the stripes; then stitch the seam.")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("3")]), _vm._v(" Pin the front pieces to the jacket back at the shoulders, with right sides facing, matching stripes. Stitch the shoulder seams. "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("B")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg16_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("4")]), _vm._v(" Sew a ¼˝ hem on each sleeve edge (see "), _c('span', {
    attrs: {
      "href": "#/34_chapter28#link38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hemming")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("5")]), _vm._v(" Stitch the underarm seams, matching the stripes.")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("6")]), _vm._v(" Stitch the collar strips together at the short ends, with right sides facing, to form a loop. Fold this in half lengthwise with the wrong sides together. "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("C")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg16_5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("7")]), _vm._v(" Pin the collar to the right side of the jacket. Match the seams on the collar to the top and bottom of the seam on the back of the jacket. "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("D")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg16_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("8")]), _vm._v(" Stitch all the way around, stretching the collar slightly. Done! "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("E")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg16_3.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "tip-head"
  }, [_c('b', [_vm._v("Caroline’s Tip")])]), _vm._v(" "), _c('p', {
    staticClass: "tip-txt"
  }, [_vm._v("If you are serging this seam, reinforce the underarm stitching for about 1˝ using your sewing machine.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34e3c06d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/08_chapter02.vue
// module id = 75
// module chunks = 0